import { useOrder } from './orderContext';
import { AuditLogsList } from '../../../audit-log/components/AuditLogsList';

export const OrderAuditLogsPage = () => {
  const { order } = useOrder();

  return <AuditLogsList filter={{ orderId: order.id }} />;
};
